import React from 'react';

export default ({ color }) => (
  <span style={{ display: 'inline-block', width: '12px', height: '12px', background: color }} />
);
